// extracted by mini-css-extract-plugin
export default {"profile":"Account_profile__r+U3x","editProfile":"Account_editProfile__h9tvl","welcome":"Account_welcome__k-f9v","modalWithForm":"Account_modalWithForm__PkedE"};